import React from 'react';
import shimbun4 from '../assets/shimbun4.png';
import shimbun5 from '../assets/shimbun5.png';
import shimbun6 from '../assets/shimbun6.png';
import shimbun7 from '../assets/shimbun7.png';
import './CSS/Interview.css';

function Interview() {
  return (
    <main className="interview-page">
      <div className="interview-masthead">
        Thai Aikikai Exclusive Interview &nbsp;·&nbsp; บทสัมภาษณ์พิเศษ &nbsp;·&nbsp; Special Feature
      </div>

      {/* HERO */}
      <section className="interview-hero">
        <img
          className="interview-hero-img"
          src={shimbun4}
          alt="ฟูกากูซ่า ชิฮัง ให้สัมภาษณ์"
        />

        <div className="interview-hero-overlay"></div>

        <div className="interview-hero-content">
          <div className="interview-hero-label">
            สัมภาษณ์พิเศษ · Exclusive Interview
          </div>

          <h1 className="interview-hero-title">
            เผยความลับเบื้องหลัง
            <br />
            <em>"ความนุ่มนวล"</em> ของไอคิโด
          </h1>

          <p className="interview-hero-subtitle">
            เมื่อท่วงท่าที่ดูเหมือนบทกวี แท้จริงแล้วซ่อนแรงโน้มถ่วงของความอยู่รอด
            และเรขาคณิตแห่งคมดาบไว้ภายใน
          </p>

          <div className="interview-hero-byline">
            <div className="interview-hero-avatar">
              <img src={shimbun4} alt="ฟูกากูซ่า ชิฮัง" />
            </div>

            <div className="interview-hero-byline-text">
              <strong>ฟูกากูซ่า ชิฮัง</strong>
              ปรมาจารย์ไอคิโด · สัมภาษณ์โดย เคนอิชิ อิชิโอกะ
            </div>
          </div>
        </div>
      </section>

      <div className="interview-article-wrap">
        <div className="interview-intro-block">
          <p>
            ภาพจำของไอคิโดในสายตาคนทั่วไปคือศิลปะการต่อสู้ที่ดูสันติวิธี —
            ฝ่ายตรงข้ามพุ่งเข้ามา ถูกจับหมุน แล้วตกลงเบาะอย่างนุ่มนวล
            ราวกับการเต้นรำ แต่เบื้องหลังความพริ้วไหวนั้น
            ซ่อนสถาปัตยกรรมของการหลบหลีกคมดาบซามูไร
            ที่พร้อมบั่นคอได้ในเสี้ยววินาที
          </p>
        </div>

        {/* SECTION 1 */}
        <div className="interview-section-header">
          <div className="interview-section-num">01</div>
          <div className="interview-section-title-wrap">
            <span>แนวคิดหลัก · Core Concept</span>
            <h2>มายาคติแห่งความนุ่มนวล</h2>
          </div>
        </div>

        <div className="interview-clearfix">
          <figure className="interview-portrait-float">
            <img
              src={shimbun5}
              alt="ฟูกากูซ่า ชิฮัง สาธิตท่าทางมือ"
            />
            <figcaption>
              ฟูกากูซ่า ชิฮัง สาธิตโครงสร้างมือ —
              ท่าทางที่ดูเรียบง่ายซ่อนการคำนวณทางการเคลื่อนไหวไว้ทั้งหมด
            </figcaption>
          </figure>

          <div className="interview-conversation">
            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                ภาพจำของไอคิโดในหัวคนส่วนใหญ่น่าจะเป็นศิลปะการต่อสู้ที่ดูสันติวิธี
                แบบคล้ายการเต้นรำใช่ไหมครับ
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ชิฮัง</span>
              </div>
              <div className="interview-exchange-text">
                ใช่ครับ ภาพที่ฝ่ายตรงข้ามพุ่งเข้ามาแล้วถูกจับหมุนตัวตกลงเบาะดูนุ่มนวล
                ยอมโอนอ่อนไปหมดเลย แต่นั่นคือสิ่งที่ผมเรียกว่า{' '}
                <strong>"มายาคติแห่งความนุ่มนวล"</strong>
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                หมายความว่ามันไม่ได้นุ่มนวลอย่างที่เห็นเหรอครับ
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ชิฮัง</span>
              </div>
              <div className="interview-exchange-text">
                คนส่วนใหญ่มองไอคิโดแล้วคิดว่าเราไม่ต้องออกแรงทำอะไรเลย
                แต่ในความเป็นจริง ท่วงท่าที่ดูเหมือนน้ำไหลเหล่านั้น
                ถูกค้ำจุนด้วยองค์ประกอบที่ <strong>ดุดันเฉียบขาด</strong>{' '}
                และต้องใช้การคำนวณที่แม่นยำมากครับ ถ้าโครงสร้างของไอคิโดขาด{' '}
                <strong>อาเตมิ</strong> และ <strong>มาไอ</strong>{' '}
                สิ่งที่เหลืออยู่ก็เป็นแค่การเต้นรำสวย ๆ ที่ใช้จริงไม่ได้เลยครับ
              </div>
            </div>
          </div>
        </div>

        <div className="interview-pull-quote">
          <p>
            "ถ้าโครงสร้างของไอคิโดขาดอาเตมิและมาไอ
            สิ่งที่เหลืออยู่ก็จะเป็นแค่การเต้นรำสวย ๆ ที่ไม่มีแรงต้าน"
          </p>
          <cite>— ฟูกากูซ่า ชิฮัง</cite>
        </div>

        <div className="interview-concept-card">
          <span className="interview-concept-jp">อาเตมิ · Atemi</span>
          <h3>การจู่โจม — เครื่องมือทางยุทธวิธี</h3>
          <p>
            ไม่ใช่การชกเพื่อหวังผลน็อกอย่างในมวยสากล
            แต่คือการโจมตีจุดบอบบาง เช่น การพุ่งมือเข้าหาดวงตาหรือสันจมูก
            เพื่อกระตุ้นปฏิกิริยาตอบสนองอัตโนมัติของร่างกาย
            ทำให้น้ำหนักตัวถ่ายไปที่ส้นเท้า
            และสมดุลพังทลายลงในเสี้ยววินาที
          </p>
        </div>

        <div className="interview-concept-card">
          <span className="interview-concept-jp">มาไอ · Ma-ai</span>
          <h3>ระยะห่าง — ทรงกลมแห่งพลัง(มันดาลา)</h3>
          <p>
            ไม่ใช่แค่การวัดว่ายืนห่างกันแค่ไหน
            แต่คือการรับรู้ถึงทรงกลมแห่งพลังที่ล้อมรอบตัวทั้งสองฝ่าย
            ระยะห่างนี้เป็นพลวัต ขยับและเปลี่ยนแปลงอยู่ทุกเสี้ยววินาที
            ปราศจากมาไอที่ถูกต้อง อาเตมิก็ไม่มีความหมาย
          </p>
        </div>

        {/* SECTION 2 */}
        <div className="interview-section-header">
          <div className="interview-section-num">02</div>
          <div className="interview-section-title-wrap">
            <span>กลไกซ่อนเร้น · Hidden Mechanics</span>
            <h2>สับสวิตช์สมองด้วยอาเตมิ</h2>
          </div>
        </div>

        <div className="interview-conversation">
          <div className="interview-exchange">
            <div className="interview-speaker-tag q">
              <span>ถาม</span>
            </div>
            <div className="interview-exchange-text">
              ถ้าฝ่ายตรงข้ามตัวใหญ่มาก แถมถูกฝึกมาให้ทนความเจ็บปวด
              การโจมตีแบบไม่หวังผลน็อกจะไม่ยิ่งทำให้เขาโกรธมากขึ้นเหรอครับ
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag a">
              <span>ชิฮัง</span>
            </div>
            <div className="interview-exchange-text">
              อาเตมิไม่ได้โจมตีเพื่อให้เกิดความเสียหายที่กล้ามเนื้อ
              แต่มันเล็งไปที่ <strong>ปฏิกิริยาตอบสนองอัตโนมัติ</strong> —
              ดวงตา สันจมูก ลูกกระเดือก ไม่ว่าผู้โจมตีจะตัวใหญ่แค่ไหน
              มนุษย์เราไม่สามารถฝืนสัญชาตญาณการกระพริบตาได้เลยครับ
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag q">
              <span>ถาม</span>
            </div>
            <div className="interview-exchange-text">
              จริงด้วยครับ ถ้ามีอะไรพุ่งเข้าตาด้วยความเร็วสูง
              เราก็ต้องผงะหน้าหนีกันทุกคน
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag a">
              <span>ชิฮัง</span>
            </div>
            <div className="interview-exchange-text">
              นั่นแหละครับ เมื่อเกิดการผงะ คางเขาจะเชิดขึ้น
              สันหลังแอ่นเล็กน้อย น้ำหนักตัวถ่ายไปที่ส้นเท้าโดยที่เขาไม่รู้ตัว
              แค่เสี้ยววินาทีที่เขาชะงักนั้น สมดุลของร่างกายจะพังทลาย
              และในจังหวะรอยต่อแคบ ๆ ตรงนั้นเองที่เทคนิคทุ่มหรือล็อกจะสอดแทรกเข้าไป
            </div>
          </div>
        </div>

        <div className="interview-pull-quote">
          <p>
            "เราไม่ได้กำลังยกหินทั้งก้อน
            แต่เราหาลิ่มไปตอกให้หินเสียสมดุล
            แล้วค่อยผลักให้มันกลิ้งลงเนินไปเอง"
          </p>
          <cite>— เคนอิชิ อิชิโอกะ, ผู้สัมภาษณ์</cite>
        </div>

        {/* SECTION 3 */}
        <div className="interview-section-header">
          <div className="interview-section-num">03</div>
          <div className="interview-section-title-wrap">
            <span>รากฐานที่แท้จริง · The Hidden Root</span>
            <h2>เรขาคณิตของคมดาบ</h2>
          </div>
        </div>

        <div className="interview-conversation">
          <div className="interview-exchange">
            <div className="interview-speaker-tag q">
              <span>ถาม</span>
            </div>
            <div className="interview-exchange-text">
              ทำไมการเคลื่อนที่ของไอคิโดถึงไม่เหมือนมวยสากลที่เน้นหลบแล้วสวนกลับเป็นเส้นตรงล่ะครับ
              มันเชื่อมโยงกับอาวุธเหรอ
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag a">
              <span>ชิฮัง</span>
            </div>
            <div className="interview-exchange-text">
              ถูกต้องครับ ความลับเบื้องหลังการเคลื่อนไหวแบบวงกลมของไอคิโด
              คือความสัมพันธ์อย่างแยกไม่ออกกับ <strong>วิชาดาบ</strong>{' '}
              โดยเฉพาะเคนจูสึ กลไกของร่างกาย การก้าวเท้า การบิดสะโพก
              องศาการวางมือตอนสู้ด้วยมือเปล่า
              แท้จริงคือโครงสร้างเดียวกันกับตอนที่ถือดาบคาตานะเลยครับ
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag q">
              <span>ถาม</span>
            </div>
            <div className="interview-exchange-text">
              เหมือนกับการเรียนขับเกียร์กระปุกก่อน
              เพื่อให้เข้าใจกลไกเครื่องยนต์อย่างถ่องแท้
              แล้วต่อให้ขับออโต้ในชีวิตประจำวัน
              ก็จะมีความเข้าใจลึกซึ้งกว่าคนที่ขับออโต้มาตั้งแต่ต้น
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag a">
              <span>ชิฮัง</span>
            </div>
            <div className="interview-exchange-text">
              เปรียบได้ดีมากครับ ถ้ามีคนพุ่งเข้ามาต่อยด้วยมือเปล่า
              เราอาจยกแขนบล็อกได้ — อย่างมากก็แค่กล้ามเนื้อฟกช้ำ
              แต่ถ้าสิ่งที่พุ่งเข้ามาคือ <strong>คมดาบคาตานะ</strong>{' '}
              การยกแขนบล็อกตรง ๆ หมายถึงการสูญเสียอวัยวะหรือเสียชีวิตทันที
              ศาสตร์ของดาบจึงบังคับให้มนุษย์คิดค้นการฉลบออกด้านข้าง
              เบี่ยงวิถีดาบเป็นวงกลมโดยไม่ต้องรับแรงตรง ๆ
            </div>
          </div>
        </div>

        {/* TWO-UP IMAGES */}
        <div className="interview-img-row">
          <figure>
            <img src={shimbun6} alt="ฟูกากูซ่า ชิฮัง ฝึกท่าโจ" />
            <figcaption>
              ท่าโจ (ไม้พลอง) — การก้าวเท้าและบิดสะโพกเป็นโครงสร้างเดียวกันกับไอคิโดมือเปล่า
            </figcaption>
          </figure>

          <figure>
            <img src={shimbun7} alt="ฟูกากูซ่า ชิฮัง ในท่าดาบ" />
            <figcaption>
              ท่าดาบในโดโจ — ใต้ภาพถ่ายของโอเซนเซ ผู้ก่อตั้งไอคิโด
            </figcaption>
          </figure>
        </div>

        <div className="interview-pull-quote">
          <p>
            "ท่วงท่าที่เราเห็นคือการจำลองสถานการณ์เอาชีวิตรอดจากการถูกฟันด้วยดาบซามูไรที่มองไม่เห็น —
            เส้นบาง ๆ ระหว่างความเป็นกับความตาย ที่ถูกย่อส่วนลงมาอยู่ในโรงฝึก"
          </p>
          <cite>— ฟูกากูซ่า ชิฮัง</cite>
        </div>

        {/* SECTION 4 */}
        <div className="interview-section-header">
          <div className="interview-section-num">04</div>
          <div className="interview-section-title-wrap">
            <span>ปรัชญาการฝึกฝน · Philosophy of Practice</span>
            <h2>Kihon — ตัวกรองเดียวของความชำนาญ</h2>
          </div>
        </div>

        <div className="interview-conversation">
          <div className="interview-exchange">
            <div className="interview-speaker-tag q">
              <span>ถาม</span>
            </div>
            <div className="interview-exchange-text">
              ผู้ฝึกยุคปัจจุบันที่เอาแต่ซ้อมมือเปล่าโดยไม่เคยหยิบดาบไม้ขึ้นมาเลย
              จะสูญเสียเจตนารมณ์ที่แท้จริงของวิชาไปหรือเปล่าครับ
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag a">
              <span>ชิฮัง</span>
            </div>
            <div className="interview-exchange-text">
              มีสิทธิ์สูงมากครับ ถ้าไม่เข้าใจรากฐานของดาบ
              การเคลื่อนไหวของไอคิโดจะดูไร้เหตุผล
              แต่ปัญหาที่ลึกกว่าคือการข้ามขั้น —
              หลายคนเห็นความลื่นไหวของโอเซนเซแล้วพยายามเลียนแบบ
              โดยกระโดดข้ามการฝึก <strong>คิฮง</strong> หรือท่าพื้นฐาน
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag q">
              <span>ถาม</span>
            </div>
            <div className="interview-exchange-text">
              เหมือนนักเรียนดนตรีที่ไปเห็นนักเปียโนแจ๊สระดับตำนานโซโล่ด้นสดอย่างอิสระ
              แล้วพยายามเลียนแบบโดยกดคีย์มั่ว ๆ
              ทั้ง ๆ ที่ตัวเองยังไล่สเกลพื้นฐานไม่ตรงจังหวะเลย
            </div>
          </div>

          <div className="interview-exchange">
            <div className="interview-speaker-tag a">
              <span>ชิฮัง</span>
            </div>
            <div className="interview-exchange-text">
              ผลลัพธ์ก็จะเป็นแค่เสียงรบกวนที่ไร้ทิศทางครับ
              คิฮงมักต้องทำซ้ำเป็นพันเป็นหมื่นครั้ง รู้สึกแข็งทื่อ
              ขัดธรรมชาติ บางครั้งก็เจ็บปวด
              แต่อิสรภาพในการเคลื่อนไหวที่แท้จริงจะเกิดขึ้นได้ก็ต่อเมื่อร่างกายและสมองซึมซับระเบียบวินัยจนมันฝังราก{' '}
              <strong>กลายเป็นสัญชาตญาณที่ไม่ต้องคิดแล้ว</strong> เท่านั้น
            </div>
          </div>
        </div>

        <div className="interview-ornament">— · · · —</div>

        <div className="interview-closing-box">
          <h3>ทิ้งท้าย: ถามตัวเองดูบ้าง</h3>

          <p>
            หากศิลปะอย่างไอคิโดที่มีภาพลักษณ์ว่านุ่มนวลประณีประนอม
            แท้จริงถูกสร้างขึ้นบนรากฐานของตรรกะที่เฉียบขาด อันตราย
            และระเบียบวินัยของวิชาดาบ ลองหันกลับมามองสิ่งรอบตัวดูสิ —
            มีระบบ องค์กร หรือแม้แต่ความสัมพันธ์รูปแบบไหนในชีวิตของคุณอีกบ้าง
            ที่ฉากหน้าดูยืดหยุ่นนุ่มนวล
            แต่เบื้องหลังกลับต้องอาศัยกฎเกณฑ์และระเบียบวินัยที่แข็งแกร่งดุจเหล็กกล้าคอยพยุงมันไว้
          </p>

          <p className="interview-closing-note">
            "ความนุ่มนวลที่เราเห็นจากภายนอก
            ไม่ใช่สัญลักษณ์ของความอ่อนแอ แต่เป็น
            <span>ความนุ่มนวลที่ทรงพลัง</span>
            เพราะมันเป็นผลผลิตของความเข้าใจในโครงสร้างและจิตวิทยาของการต่อสู้อย่างถ่องแท้"
            — ฟูกากูซ่า ชิฮัง
          </p>
        </div>
      </div>

      <footer className="interview-footer">
        <strong>Thai Aikikai</strong>
        <br />
        บทสัมภาษณ์นี้ดัดแปลงและเรียบเรียงจากบทสนทนาต้นฉบับจากช่อง YouTube Aikido Renbukan BKK
      </footer>
    </main>
  );
}

export default Interview;
